var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_vm.saving ? _c('div', {
    staticClass: "absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
  }, [_c('span', {
    staticClass: "h-6 w-6 ml-4 mt-1/4 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.saveRole.apply(null, arguments);
      }
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_vm.isNewRole ? _c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("Ajouter un nouveau rôle")]) : _c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("\n      Modifier les droits d'accès "), _c('br'), _vm._v("du rôle \"" + _vm._s(_vm.roleToEdit.name) + "\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full mb-15"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 justify-center gap-x-0 md:gap-x-4"
  }, [_c('div', {
    staticClass: "col-span-full sm:col-span-1"
  }, [_c('input-text', {
    staticClass: "mr-4",
    attrs: {
      "name": "name",
      "libelle": "Nom du rôle",
      "value": _vm.roleToEdit.name
    },
    on: {
      "click": function ($event) {
        return _vm.SET_ERRORS(null);
      },
      "input": function (newValue) {
        _vm.$set(_vm.roleToEdit, 'name', newValue);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full sm:col-span-1"
  }, [_c('input-text', {
    attrs: {
      "name": "description",
      "libelle": "Description",
      "value": _vm.roleToEdit.description
    },
    on: {
      "input": function (newValue) {
        _vm.$set(_vm.roleToEdit, 'description', newValue);
      }
    }
  })], 1)]), _vm._v(" "), _c('v-errors', {
    staticClass: "text-sm font-medium text-red-500 w-full",
    attrs: {
      "errors": Object.assign({}, _vm.errors)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full text-left text-pink-600 text-lg mb-15"
  }, [_vm._v("\n      DROITS ET RESTRICTIONS\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "odd:bg-indigo-100 odd:bg-opacity-50 w-full"
  }, [_c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center",
    class: {
      'bg-indigo-200 border-l-2 border-indigo-600': _vm.groupPermissionsDisplay == _vm.constants.PERMISSION_NEOPASS_FORM_PAGE
    },
    attrs: {
      "id": "accordion_neopass_form"
    },
    on: {
      "click": function ($event) {
        return _vm.displayGroupPermissions(_vm.constants.PERMISSION_NEOPASS_FORM_PAGE);
      }
    }
  }, [_c('div', {
    staticClass: "col-span-1 text-pink-600 place-self-center"
  }, [_c('icon', {
    staticClass: "inline-block transform transition-transform ease-in-out duration-300",
    class: {
      'rotate-90': _vm.groupPermissionsDisplay == _vm.constants.PERMISSION_NEOPASS_FORM_PAGE
    },
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-11 w-full text-base"
  }, [_vm._v("\n          Formulaire carnet de parcours\n        ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.groupPermissionsDisplay == _vm.constants.PERMISSION_NEOPASS_FORM_PAGE ? _c('div', {
    staticClass: "w-full bg-white grid grid-cols-2 justify-start pt-10"
  }, [_c('div', {
    staticClass: "col-span-full sm:col-span-1"
  }, [_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read');
  }).length > 0 ? _c('div', [_c('checkbox-indigo', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "Lecture",
      "libelle": "LECTURE",
      "color-libelle": "indigo-600",
      "value": ((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {}).all,
      "size-libelle": "text-base"
    },
    on: {
      "input": function (newValue) {
        ((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {}).all = newValue;
        _vm.checkallNeopassForm('read', 'all', newValue);
        if (!newValue) {
          ((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {}).all = newValue;
          _vm.checkallNeopassForm('edit', 'all', newValue);
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read');
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {}).all = newValue;
          _vm.checkallNeopassForm('read', mod.name, newValue);
          _vm.decheckallNeopassForm('read', mod.name, newValue);
          if (!newValue) {
            (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {}).all = newValue;
            _vm.checkallNeopassForm('edit', mod.name, newValue);
            _vm.decheckallNeopassForm('edit', mod.name, newValue);
          }
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return _vm.permissions.includes(p.name + '_read') && p.name != _vm.constants.PAGE_NEOPASS_FORM_DOCUMENTS;
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        staticClass: "text-gray-600",
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "color-libelle": "gray-600",
          "value": (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name],
          "size-libelle": "text-base",
          "weight-libelle": "font-light"
        },
        on: {
          "input": function (newValue) {
            (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name] = newValue;
            _vm.decheckallNeopassForm('read', mod.name, newValue);
            if (!newValue) {
              (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name] = newValue;
              _vm.decheckallNeopassForm('edit', mod.name, newValue);
            }
          }
        }
      })], 1);
    }), _vm._v(" "), _vm.permissions.includes(mod.name + '_auto_eval_read') ? _c('checkbox-indigo', {
      staticClass: "text-gray-600",
      attrs: {
        "name": mod.name + '_auto_eval_read',
        "libelle": "Auto Evaluation Bénéficiaire",
        "color-libelle": "gray-600",
        "value": (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'],
        "size-libelle": "text-base",
        "weight-libelle": "font-light"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'] = newValue;
          _vm.decheckallNeopassForm('read', mod.name, newValue);
          if (!newValue) {
            (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'] = newValue;
            _vm.decheckallNeopassForm('edit', mod.name, newValue);
          }
        }
      }
    }) : _vm._e()], 2);
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-span-full sm:col-span-1"
  }, [_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_edit');
  }).length > 0 ? _c('div', [_c('checkbox-indigo', {
    staticClass: "w-1/2 text-indigo-600",
    attrs: {
      "name": "Ecriture",
      "libelle": "ECRITURE",
      "color-libelle": "indigo-600",
      "value": ((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {}).all,
      "size-libelle": "text-base"
    },
    on: {
      "input": function (newValue) {
        ((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {}).all = newValue;
        _vm.checkallNeopassForm('edit', 'all', newValue);
        if (newValue) {
          ((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {}).all = newValue;
          _vm.checkallNeopassForm('read', 'all', newValue);
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_edit');
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {}).all = newValue;
          _vm.checkallNeopassForm('edit', mod.name, newValue);
          _vm.decheckallNeopassForm('edit', mod.name, newValue);
          if (newValue) {
            (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {}).all = newValue;
            _vm.checkallNeopassForm('read', mod.name, newValue);
          }
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return _vm.permissions.includes(p.name + '_edit') && p.name != _vm.constants.PAGE_NEOPASS_FORM_DOCUMENTS;
    }), function (page, numPage) {
      return _c('span', {
        key: numPage
      }, [_c('checkbox-indigo', {
        staticClass: "text-gray-600",
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "color-libelle": "gray-600",
          "value": (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name],
          "size-libelle": "text-base",
          "weight-libelle": "font-light"
        },
        on: {
          "input": function (newValue) {
            (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name] = newValue;
            _vm.decheckallNeopassForm('edit', mod.name, newValue);
            if (newValue) {
              (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name] = newValue;
            }
          }
        }
      })], 1);
    }), _vm._v(" "), _vm.permissions.includes(mod.name + '_auto_eval_edit') ? _c('checkbox-indigo', {
      staticClass: "text-gray-600",
      attrs: {
        "name": mod.name + '_auto_eval_edit',
        "libelle": "Auto Evaluation Bénéficiaire",
        "color-libelle": "gray-600",
        "value": (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'],
        "size-libelle": "text-base",
        "weight-libelle": "font-light"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'] = newValue;
          _vm.decheckallNeopassForm('edit', mod.name, newValue);
          if (newValue) {
            (((((_vm.roleToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'] = newValue;
          }
        }
      }
    }) : _vm._e()], 2);
  })], 2)]) : _vm._e()])], 1), _vm._v(" "), _vm._l(_vm.filteredListPermissions, function (group, num_grp) {
    return _c('div', {
      key: num_grp,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.groupPermissionsDisplay == group.module
      },
      attrs: {
        "id": 'accordion_' + group.module
      },
      on: {
        "click": function ($event) {
          return _vm.displayGroupPermissions(group.module);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-1 text-pink-600 place-self-center"
    }, [_c('icon', {
      staticClass: "inline-block transform transition-transform ease-in-out duration-300",
      class: {
        'rotate-90': _vm.groupPermissionsDisplay == group.module
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-11 text-base place-self-center justify-self-start"
    }, [_vm._v("\n          " + _vm._s(group.display_name) + "\n        ")])]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_vm.groupPermissionsDisplay == group.module ? _c('div', {
      staticClass: "bg-white grid grid-cols-2 gap-x-4 gap-y-5 py-5"
    }, [_c('div', {
      staticClass: "col-span-full"
    }, [_c('checkbox-indigo', {
      attrs: {
        "name": "tout",
        "libelle": _vm.getLibelle(group),
        "color-libelle": "indigo-600",
        "value": (((_vm.roleToEdit || {}).rights || {})[group.module] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          (((_vm.roleToEdit || {}).rights || {})[group.module] || {}).all = newValue;
          _vm.checkallModule(group.module, newValue);
        }
      }
    })], 1), _vm._v(" "), _vm._l(_vm.filterPermissions(group), function (func, num_func) {
      return _c('div', {
        key: num_func,
        staticClass: "col-span-full sm:col-span-1"
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": func.name,
          "libelle": func.display_name,
          "color-libelle": "indigo-600",
          "value": (((_vm.roleToEdit || {}).rights || {})[group.module] || {})[func.name],
          "size-libelle": "text-base"
        },
        on: {
          "input": function (newValue) {
            (((_vm.roleToEdit || {}).rights || {})[group.module] || {})[func.name] = newValue;
            _vm.decheckallModule(group.module, newValue);
          }
        }
      })], 1);
    }), _vm._v(" "), [_vm.constants.MODULE_FICHE_DE_POSTE, _vm.constants.MODULE_REFERENTIEL_FORMATION].includes(group.module) ? _c('div', {
      staticClass: "col-span-full grid grid-cols-2 gap-x-4 gap-y-5 self-start"
    }, [_c('div', {
      staticClass: "col-span-full"
    }, [_c('checkbox-indigo', {
      attrs: {
        "name": "tout_personnal_library",
        "libelle": "Tout dans bibliothèque personnelle",
        "color-libelle": "indigo-600",
        "value": (((_vm.roleToEdit || {}).rights || {})[group.module] || {}).allPersonnal,
        "size-libelle": "col-span-1 text-base mb-3"
      },
      on: {
        "input": function (newValue) {
          (((_vm.roleToEdit || {}).rights || {})[group.module] || {}).allPersonnal = newValue;
          if (group.module === _vm.constants.MODULE_FICHE_DE_POSTE) _vm.checkAllFicheDePostePersonnalLibrary(newValue);
          if (group.module === _vm.constants.MODULE_REFERENTIEL_FORMATION) _vm.checkAllReferentielFormationPersonnalLibrary(newValue);
          _vm.decheckallModule(group.module, newValue);
        }
      }
    })], 1), _vm._v(" "), _vm._l(_vm.listPermissions.filter(function (p) {
      return p.module == group.module && [_vm.constants.MODULE_FICHE_DE_POSTE, _vm.constants.MODULE_REFERENTIEL_FORMATION].includes(p.module) && p.type == 'function' && (p.module === _vm.constants.MODULE_FICHE_DE_POSTE && p.name.includes('job_description_personnal') || p.module === _vm.constants.MODULE_REFERENTIEL_FORMATION && p.name.includes('ref_formations_personnal')) && ![_vm.constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_LISTE, _vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_LISTE].includes(p.name);
    }), function (func, num_func) {
      return _c('div', {
        key: num_func,
        staticClass: "col-span-full sm:col-span-1"
      }, [_c('checkbox-indigo', {
        staticClass: "truncate",
        attrs: {
          "name": func.name,
          "libelle": func.display_name,
          "color-libelle": "indigo-600",
          "value": (((_vm.roleToEdit || {}).rights || {})[group.module] || {})[func.name],
          "size-libelle": "text-base"
        },
        on: {
          "input": function (newValue) {
            (((_vm.roleToEdit || {}).rights || {})[group.module] || {})[func.name] = newValue;
            if (_vm.p.module === _vm.constants.MODULE_FICHE_DE_POSTE) _vm.decheckAllFicheDePostePersonnalLibrary(newValue);
            if (_vm.p.module === _vm.constants.MODULE_REFERENTIEL_FORMATION) _vm.decheckAllReferentielFormationPersonnalLibrary(newValue);
            _vm.decheckallModule(group.module, newValue);
          }
        }
      })], 1);
    })], 2) : _vm._e(), _vm._v(" "), [_vm.constants.MODULE_FICHE_DE_POSTE, _vm.constants.MODULE_REFERENTIEL_FORMATION].includes(group.module) ? _c('div', {
      staticClass: "col-span-full grid grid-cols-2 gap-x-4 gap-y-5 self-start"
    }, [_c('div', {
      staticClass: "col-span-full"
    }, [_c('checkbox-indigo', {
      attrs: {
        "name": "tout_shared_library",
        "libelle": "Tout dans bibliothèque commune",
        "color-libelle": "indigo-600",
        "value": (((_vm.roleToEdit || {}).rights || {})[group.module] || {}).allShared,
        "size-libelle": "col-span-1 text-base mb-3"
      },
      on: {
        "input": function (newValue) {
          (((_vm.roleToEdit || {}).rights || {})[group.module] || {}).allShared = newValue;
          if (group.module === _vm.constants.MODULE_FICHE_DE_POSTE) _vm.checkAllFicheDePosteSharedLibrary(newValue);
          if (group.module === _vm.constants.MODULE_REFERENTIEL_FORMATION) _vm.checkAllReferentielFormationSharedLibrary(newValue);
          _vm.decheckallModule(group.module, newValue);
        }
      }
    })], 1), _vm._v(" "), _vm._l(_vm.listPermissions.filter(function (p) {
      return p.module == group.module && [_vm.constants.MODULE_FICHE_DE_POSTE, _vm.constants.MODULE_REFERENTIEL_FORMATION].includes(p.module) && p.type == 'function' && (p.module === _vm.constants.MODULE_FICHE_DE_POSTE && p.name.includes('job_description_shared') || p.module === _vm.constants.MODULE_REFERENTIEL_FORMATION && p.name.includes('ref_formations_shared')) && ![_vm.constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_LISTE, _vm.constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_LISTE].includes(p.name);
    }), function (func, num_func) {
      return _c('div', {
        key: num_func,
        staticClass: "col-span-full sm:col-span-1"
      }, [_c('checkbox-indigo', {
        staticClass: "truncate",
        attrs: {
          "name": func.name,
          "libelle": func.display_name,
          "color-libelle": "indigo-600",
          "value": (((_vm.roleToEdit || {}).rights || {})[group.module] || {})[func.name],
          "size-libelle": "text-base"
        },
        on: {
          "input": function (newValue) {
            (((_vm.roleToEdit || {}).rights || {})[group.module] || {})[func.name] = newValue;
            if (_vm.p.module === _vm.constants.MODULE_FICHE_DE_POSTE) _vm.decheckAllFicheDePosteSharedLibrary(newValue);
            if (_vm.p.module === _vm.constants.MODULE_REFERENTIEL_FORMATION) _vm.decheckAllReferentielFormationSharedLibrary(newValue);
            _vm.decheckallModule(group.module, newValue);
          }
        }
      })], 1);
    })], 2) : _vm._e()], 2) : _vm._e()])], 1);
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }